export var getActiveCampaign = function (state) {
    return state.engagement.engageV2.activeCampaign;
};
export var getEditableField = function (state, field) {
    return getActiveCampaign(state).editableFields[field];
};
export var getIsInitialized = function (state) {
    return getActiveCampaign(state).isInitialized;
};
export var getIsProcessing = function (state) {
    return getActiveCampaign(state).isProcessing;
};
export var getIsNewCampaign = function (state) {
    return getActiveCampaign(state).isNewCampaign;
};
export var getIsDraft = function (state) {
    return getActiveCampaign(state).isDraft;
};
